import styled from 'styled-components'
import { colors, newColors, fontSizes } from '@sabavision/dio'
import { imageBaseUrl } from '../../config'

export const Wrapper = styled.div`
  position: relative;
  top: 0;
  right: 0;
  height: 100vh;
  width: 60px;
  font-family: IRANSans;
`

export const Container = styled.div`
  position: relative;
  top: 0;
  right: 0;
  height: 100vh;
  font-family: IRANSans;
  z-index: 10;
  display: flex;
  flex-direction: row;
  flex-wrap: no-wrap;
  backdrop-filter: blur(5px);
  &.open {
    width: 100vw;
  }
`

export const MenuContainer = styled.div`
  position: relative;
  top: 0;
  right: 0;
  min-width: 60px;
  height: 100%;
  background: ${colors.white};
  box-shadow: -5px 4px 4px rgba(179, 186, 182, 0.25);
  border-radius: 0;
  z-index: 1;
  transition: 0.5s ease-in-out;

  &.open {
    min-width: 120px;
    font-family: IRANSans;
    .label {
      width: 100%;
      padding-inline-start: 10px;
      transition: width 0.5s ease-in 0.5s !important;
    }
    .item {
      justify-content: flex-start;
    }
    .footer {
      transition-delay: 0.3s;
      width: 119px;
      .footer-container {
        align-items: flex-start;
        padding-inline-start: 10px;
        .profile {
          .indicator {
            right: 98px;
          }
        }
      }
    }
    .divider {
      width: 85%;
    }
  }

  .bottomLeft {
    top: 0 !important;
    bottom: auto !important;
    right: 55px !important;
  }
`

export const Expand = styled.div`
  position: absolute;
  top: 50px;
  left: -9px;
  width: 19px;
  height: 19px;
  background: ${colors.white};
  border-radius: 50%;
  box-shadow: -5px 4px 4px rgba(179, 186, 182, 0.25);
  cursor: pointer;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    top: -9px;
    left: -1px;
    width: 10px;
    height: 10px;
    background: #9b7d7d00;
    border-radius: 50%;
    box-shadow: 7px 4px ${colors.white};
  }

  &::after {
    content: '';
    position: absolute;
    top: 18px;
    right: 10px;
    width: 10px;
    height: 10px;
    background: transparent;
    border-radius: 50%;
    box-shadow: 7px -4px ${colors.white};
  }
  img,
  span {
    z-index: 10;
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 12px;
    height: 12px;
    border: 0.5px solid ${colors.white};
    outline: 1px solid ${colors.success};
    border-radius: 50%;
    color: ${colors.white};
    background: ${colors.seaGreen};
    font-size: 12px;
  }
`

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 18px;
  width: 100%;
  height: 50px;
  img {
    max-width: 55%;
  }
`

export const Icon = styled.span`
  font-size: 1.25rem;
`

export const Label = styled.span`
  box-sizing: border-box;
  width: 0;
  height: 20px;
  font-family: 'IRANSans';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.s2};
  line-height: 20px;
  overflow: hidden;
  &.name {
    max-width: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

export const Menu = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`

export const MenuItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  padding: 4px;
  color: ${colors.silverSand};
  height: 28px;
  cursor: pointer;
  &.active {
    background: ${colors.clearDay} !important;
    color: ${colors.seaGreen};
  }
  &.menu-item:hover {
    background: ${colors.cultured};
  }
`

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  padding-block-end: 60px;
  width: 60px;
  background: ${colors.white} url('${imageBaseUrl}/images/background/wave-form4.svg');
  .footer-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .in-person {
      transform: rotate(90deg) translateX(-50%);
      width: 150px;
    }
  }
  .profile {
    position: relative;
    .indicator {
      position: absolute;
      right: 37px;
      font-size: 1rem;
      transition: 0.5s right;
    }
  }
`

export const Divider = styled.hr`
  width: 90%;
  border-top: 0.5px solid ${colors.silverSand};
`

export const AvatarPic = styled.div`
  position: relative;
  width: 31px;
  height: 31px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${colors.clearDay};
  .icon {
    color: ${colors.seaGreen};
  }
  img {
    width: 31px;
    height: 31px;
    border-radius: 50%;
    object-fit: fill;
  }
  div {
    position: absolute;
    top: 0;
    right: 2.5px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: ${colors.royalOrange};
    outline: 1px solid ${colors.white};
  }
`

export const ProfileContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  width: 0;
  height: 100vh;
  overflow: hidden;

  &.open {
    width: 394px;
  }

  .menu,
  .sections {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    box-shadow:
      -9px 4px 10px -7px rgba(221, 237, 229, 0.12),
      inset 5px -5px 4px -2px #d6e1dc;
    border-start-end-radius: 25px;
    border-end-end-radius: 25px;
    background-color: ${colors.white};
    background-image: url(${imageBaseUrl}/images/background/wave-form3.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: bottom center;
  }
  .sections {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateX(394px);
    transition: transform 0.25s linear;
    &.open {
      transform: translateX(0);
    }
  }

  textarea {
    width: 100% !important;
  }
`

export const Body = styled.div`
  border-radius: 25px;
  position: relative;
  top: -20px;
  background-color: transparent;
  width: 100%;
  padding-top: 30px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 4px;
    width: calc(100% - 4px);
    height: 25px;
    background: ${newColors.white};
    border-radius: 25px 25px 0 0;
  }
  .max-container {
    width: 280px;
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: center;
  gap: 28px;
  flex-wrap: wrap;
`

export const ProfilePic = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 94px;
  height: 94px;
  background: ${colors.whiteIce};
  border-radius: 50%;
  border: 2px solid #bdf2eb;
  color: ${colors.paleTurquoise};
  font-size: 3.5rem;
  .avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 94px;
    height: 94px;
    background: ${colors.whiteIce};
    border-radius: 50%;
    border: 2px solid #bdf2eb;
    object-fit: fill;
  }
`

export const Wallet = styled.div`
  display: flex;
  position: absolute;
  border-radius: 10px;
  border: 1.5px solid #d7eeea;
  box-shadow: 0px 4px 4px rgba(208, 255, 249, 0.15);
  top: -16px;
  background: ${colors.white};
  height: 23px;
  &.section-name {
    box-sizing: border-box;
    min-width: 155px;
    height: 40px;
    .name {
      width: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      font-style: normal;
      font-weight: 700;
      font-size: ${fontSizes.m1};
      line-height: 24px;
      color: ${colors.graniteGray};
      .icon {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        width: 31px;
        height: 31px;
        color: ${newColors.success};
        background: #f0fff8;
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  &.wallet-data {
    padding: 4px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    inset-inline-start: 30px;
    inset-inline-end: 40px;
    .iconsax-add {
      font-size: 12px;
      font-weight: 700;
    }
  }
  &.hide {
    display: none;
    width: 0;
  }
  .wallet {
    display: flex;
    font-weight: 400;
    font-size: ${fontSizes.m1};
    color: ${colors.spanishGray};
    .credit {
      font-style: normal;
      font-weight: 700;
      font-size: ${fontSizes.m2};
      line-height: 25px;
      color: ${colors.oceanGreen};
      margin-inline: 8px;
    }
    .unit {
      font-style: normal;
      font-weight: 400;
      font-size: ${fontSizes.m1};
      line-height: 24px;
      color: ${colors.silverSand};
    }
  }
`

export const AddButton = styled.button`
  background: ${colors.oceanGreen};
  width: 19px;
  height: 19px;
  border-radius: 50%;
  color: ${colors.white};
  justify-content: center;
  border: none;
  align-items: center;
`

export const Links = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-block: 18px;
  width: calc(100% - 4px);
  border-end-end-radius: 33px;

  .social-addresses {
    display: flex;
    justify-content: center;
    gap: 19px;
    color: ${colors.silverSand};
    margin-top: 15px;
  }
  img {
    width: 120px;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  border-start-end-radius: 25px;
  padding-inline: 16px 33px;
  background-size: cover;
  width: 340px;
  &.close {
    padding-block: 19px 40px;
    .small {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 340px;
      button {
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      }
      .iconsax-arrow-right-3 {
        font-size: 1rem !important;
      }
    }
    .row {
      display: flex;
      align-items: center;
      .user {
        font-style: normal;
        font-weight: 400;
        font-size: ${fontSizes.s2};
        line-height: 20px;
        color: ${colors.spanishGray};
        display: flex;
        align-items: center;
      }
      .dio-person {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: ${colors.whiteIce};
        border: 1px solid #bdf2eb;
        color: #bdf2eb;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-inline-end: 4px;
      }
      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: ${colors.whiteIce};
        border: 1px solid #bdf2eb;
        color: #bdf2eb;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-inline-end: 4px;
        object-fit: fill;
      }
    }
  }
  &.open {
    padding-block: 50px;
    justify-content: center;
    .large {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .role {
      position: relative;
      font-style: normal;
      font-weight: 700;
      font-size: ${fontSizes.s2};
      line-height: 20px;
      color: ${colors.graniteGray};
      padding-block: 9px 5px;
      .name {
        display: inline-block;
        min-height: 19px;
        text-align: center;
      }
      .logout {
        position: absolute;
        left: -25px;
        color: #979797;
        margin-inline-start: 20px;
        transform: rotate(180deg);
        font-size: 1.15rem;
        cursor: pointer;

        &.center {
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .mobile {
      font-style: normal;
      font-weight: 400;
      font-size: ${fontSizes.s2};
      line-height: 20px;
      color: ${colors.spanishGray};
      font-family: IRANSans;
    }
  }
  &.hide {
    width: 0;
    display: none;
  }
`

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  height: calc(100vh - 115px);
  overflow: auto;
  padding-inline: 18px;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 2.5px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.silverSand};
    border-radius: 2.5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.silverSand};
  }
  &.align-stretch {
    align-items: stretch;
  }
  .direction-corrector {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 5px;
  }
  .profile-buttonGroup {
    * {
      border-radius: 10px !important;
    }
    button {
      padding: 3px 13px !important;
    }
  }
  .title {
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.m1};
    line-height: 24px;
    color: ${colors.oceanGreen};
    align-self: flex-start;
    span {
      margin-inline-end: 5px;
    }
  }
  .uploader {
    align-self: flex-start;
    display: flex;
    margin-top: 15px;
    flex-direction: column;
    .uploader-title {
      font-style: normal;
      font-weight: 400;
      font-size: ${fontSizes.m1};
      line-height: 24px;
      color: ${newColors.text};
      margin-bottom: 10px;
      .required {
        color: ${colors.warning};
      }
    }
  }
  .divider {
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.m1};
    line-height: 24px;
    color: ${colors.oceanGreen};
    align-self: flex-start;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 5px;
    margin-bottom: 15px;
    > span {
      position: absolute;
      display: flex;
      align-items: center;
      gap: 5px;
      height: 24px;
      background: ${colors.white};
      padding-inline-end: 9px;
      top: 0;
    }
    &::after {
      content: '';
      height: 0.5px;
      background: ${colors.silverSand};
      width: 100%;
      margin-top: 11px;
    }
  }
`

export const BankDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 40px;
  padding-bottom: 20px;
  gap: 25px;

  .bank-input-status {
    color: ${newColors.primaryLight};
    font-size: ${fontSizes.m1};
    font-weight: 400;
    border-bottom: solid 0.5px ${newColors.primaryLight};
    cursor: pointer;
    align-self: flex-start;
  }
`

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 10px;
  gap: 10px;
  flex-grow: 1;
`

export const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-inline: 20px;
  padding-top: 10px;
  gap: 10px;
  flex-grow: 1;
  align-self: stretch;
  .form {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 10px;
    .phone {
      display: grid;
      grid-template-columns: 4fr 2fr;
      gap: 7px;
    }
  }
`

export const DepositContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 40px;
  gap: 25px;
  flex-grow: 1;
  .input {
    input {
      width: 100% !important;
    }
  }
`

export const SettingContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding-top: 40px;
  flex-grow: 1;
`

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
`
